import { useHistory } from "react-router-dom";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";

function ReturnDropdown({
  dropdownOpen,
  toggle,
  returnOrders,
  orderData,
  direction = "down",
  ...args
}) {
  const history = useHistory();
  return (
    <div className="d-flex">
      <Dropdown isOpen={dropdownOpen} toggle={toggle} direction={direction}>
        <DropdownToggle color="primary" className="rounded-2" size="sm" caret>
          Return Orders
        </DropdownToggle>
        <DropdownMenu {...args}>
          {returnOrders
            ?.sort((a, b) => b.date_created - a.date_created)
            ?.map((i, idx) => {
              return (
                <DropdownItem
                  onClick={() => {
                    history.push({
                      pathname: `/admin/return-order-details/${i?._id}`,
                      state: { order: i, isEdit: true },
                    });
                  }}
                >
                  R{i?.id}-{idx + 1}
                </DropdownItem>
              );
            })}
        </DropdownMenu>
      </Dropdown>
    </div>
  );
}

export default ReturnDropdown;
